angular.module('gym.membership-plans').factory('MembershipIntervalUnits', function() {
  return {
    days: 'day(s)',
    weeks: 'week(s)',
    months: 'month(s)',
    years: 'year(s)'
  };
});
